import { Box, LinearProgress } from "@mui/material";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { useTopLoader } from "../../hooks/useTopLoader";

export function TopLoader() {
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();

  const active = isFetching + isMutating > 0;

  const { visible, progress } = useTopLoader(active, 200);

  console.log({progress})

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: (theme) => theme.zIndex.tooltip + 1,
      }}
    >
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 3,
          backgroundColor: "transparent", // removes grey track
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#962EFF",
            boxShadow: "0 0 8px rgba(150,46,255,0.6)", // optional glow
          },
        }}
      />
    </Box>
  );
}
